import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { updateData} from "../../../lib/sessionschedule";
import { getInstructorIdData as getInstructorDataforStudents } from "../../../lib/sessionscheduleview";
import { useAuth } from "../../../usercontext";
import ScheduleNote from "./schedulenote";

export default function InstructorScheduleDays({ slug }) {
  const [instructorSchedule, setInstructorSchedule] = useState([]);
  const [sNote, setSNote] = useState("");
  const { profile, setProfile } = useAuth();

  async function GetInstructorScheduleData() {
      const sched = await getInstructorDataforStudents(profile.id,slug);
      setInstructorSchedule(sched);
      //console.log("sched",sched);
  }
  async function ChangeTaskStatus(scheduleId, status) {
    await updateData({
      id: scheduleId,
      status: status,
    });
    GetInstructorScheduleData();
  }

  useEffect(() => {
    GetInstructorScheduleData();
  }, []);

  return (
    <div className="col-xl-12 col-md-12 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-1">
          <div className="personal-info-head px-3 p-1 d-flex justify-content-between">
              <h4>Student Schedule</h4>

              <Link to ={`/instructor/instructor-addschedule?studentId=${slug}`} className="btn btn-secondary">
                Add New Date
              </Link>
            </div>
            {/* <hr className="mt-2" /> */}
            <div className="comman-space pb-0">
              <div className="settings-referral-blk course-instruct-blk  table-responsive">
                {/* Instructor Users */}
                <table className="table ">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Student</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {instructorSchedule
                      ? instructorSchedule.map(function (data, ix) {
                          return (
                            <>
                              <tr key={data.id}>
                                <td>{data.id}</td>
                                <td>{data.studentname}</td>
                                <td>{data.ldate}</td>
                                <td>{data.ltime.substring(0, 5)}</td>
                                        <td className="mt-4">
                                          <div className="select-container2 mx-2">
                                            <select
                                               value={data.status}
                                              onChange={(e) =>
                                                ChangeTaskStatus(
                                                  data.id,
                                                  e.target.value
                                                )
                                              }
                                              className={
                                                data.status === "Absent"
                                                  ? "select-box bg-danger-subtle"
                                                  : data.status === "Late"
                                                  ? "select-box bg-warning-subtle"
                                                  : data.status === "Present"
                                                  ? "select-box bg-success-subtle"
                                                  : data.status === "Parent"
                                                  ? "select-box bg-primary"
                                                  : data.status === "Made-up"
                                                  ? "select-box bg-dark-subtle"
                                                  : "select-box"
                                              }
                                            >
                                              <option
                                                key={0}
                                                value=""
                                                selected={data.status === ""}
                                              >
                                                Select
                                              </option>
                                              <option
                                                key={1}
                                                value="Absent"
                                                selected={data.status === "Absent"}
                                              >
                                                Absent
                                              </option>
                                              <option
                                               key={2}
                                               value="Late"
                                               selected={data.status === "Late"}
                                              >
                                                Late
                                              </option>
                                              <option
                                               key={3}
                                               value="Present"
                                               selected={
                                                 data.status === "Present"
                                               }
                                              >
                                                Present
                                              </option>
                                               <option
                                               key={4}
                                               value="Parent"
                                               selected={
                                                 data.status === "Parent"
                                               }
                                              >
                                                Parent
                                              </option>
                                               <option
                                               key={5}
                                               value="Made-up"
                                               selected={
                                                 data.status === "Made-up"
                                               }
                                              >
                                                Made-up
                                              </option>
                                            </select>
                                          </div>
                                        </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-outline-info"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseAnswer${ix}`}
                                    aria-expanded="false"
                                    aria-controls={`#collapseAnswer${ix}`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-arrows-angle-expand"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                                      />
                                    </svg>
                                  </button>
                                </td>
                              </tr>
                              <tr
                                className="collapse"
                                id={`collapseAnswer${ix}`}
                              >
                                <td colSpan={8}>
                                  <ScheduleNote
                                    value={data.note ? data.note : ""}
                                    setValue={setSNote}
                                    scheduleId={data.id}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
                {/* Instructor List */}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}
